{
  "commandCenter": {
    "title": "Centre de commandes",
    "description": "Tapez une commande — le nom d'un canvas pour l'ouvrir.",
    "inputLabel": "Commande",
    "placeholder": "Aller à un canvas…",
    "listLabel": "Commandes",
    "empty": "Aucune commande",
    "noMatch": "Aucun résultat pour « {{query}} ».",
    "current": "Actuel",
    "groups": {
      "bookmarks": "Favoris",
      "canvases": "Canvas",
      "sharedCanvases": "Partagés avec moi"
    },
    "footer": {
      "navigate": "naviguer",
      "run": "exécuter",
      "close": "fermer"
    }
  },
  "sidebar": {
    "title": "Barre latérale",
    "description": "Affiche la barre latérale mobile.",
    "toggle": "Afficher ou masquer la barre latérale"
  },
  "blocknote": {
    "loadingEditor": "Chargement de l'éditeur",
    "documentTooLarge": "Ce document est trop volumineux : les nouvelles modifications ne seront pas enregistrées tant qu'il n'aura pas été raccourci.",
    "renderError": "Impossible d'afficher ce contenu."
  },
  "corruptedDocument": {
    "title": "Impossible de charger ce document",
    "description": "Son contenu est corrompu et n'a pas pu être affiché. Il reste récupérable depuis le serveur tant que vous n'avez pas confirmé, mais continuer le supprimera définitivement.",
    "continue": "Continuer (supprimer le contenu corrompu)"
  },
  "upload": {
    "failed": "Échec de l'import du fichier",
    "failedWithStatus": "Échec de l'import ({{status}})"
  },
  "datePill": {
    "pick": "Choisir une date",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "tomorrow": "Demain"
  },
  "slashMenu": {
    "date": {
      "title": "Date",
      "subtext": "Insérer une pastille de date"
    },
    "pill": {
      "title": "Pastille",
      "subtext": "Insérer une pastille colorée"
    },
    "callout": {
      "title": "Encadré",
      "subtext": "Insérer un encadré coloré avec une icône"
    }
  },
  "callout": {
    "title": "Titre",
    "levelText": "Texte",
    "color": "Couleur",
    "defaultColor": "Par défaut"
  },
  "pill": {
    "variants": {
      "pastel": "Pastel",
      "solid": "Plein"
    }
  },
  "mention": {
    "notFound": "Node introuvable",
    "tooltip": "{{label}} — cliquez pour y aller, {{modifier}}+clic pour l'ouvrir"
  },
  "noleComment": {
    "label": "Commenter pour Nolë",
    "tooltip": "Ajoute le passage et votre commentaire à la conversation",
    "button": "Commenter"
  },
  "nodeTypes": {
    "link": "Liens",
    "image": "Images",
    "blocknote": "Notes",
    "value": "Valeurs",
    "title": "Titres",
    "file": "Fichiers",
    "table": "Tableaux",
    "app": "Apps",
    "audio": "Audio",
    "video": "Vidéos",
    "frame": "Frames",
    "board": "Boards",
    "custom": "Custom nodes",
    "database": "Bases de données",
    "databaseView": "Vues de base de données"
  },
  "relativeTime": {
    "justNow": "à l'instant",
    "minutes": "{{value}} min",
    "hours": "{{value}} h",
    "days": "{{value}} j"
  },
  "search": {
    "placeholder": {
      "titles": "Rechercher dans les titres — \"expression\", -exclure, a OR b",
      "semantic": "Recherche sémantique — décrivez l'idée",
      "keyword": "Rechercher — \"expression\", -exclure, a OR b"
    },
    "clear": "Effacer la recherche",
    "titlesOnly": "Titres seulement",
    "noResults": "Aucun résultat",
    "noNodes": "Aucun node pour l'instant",
    "recent": "Récents",
    "relaxed": "Aucun résultat exact — résultats approchants affichés.",
    "resultCount_one": "{{count}} résultat",
    "resultCount_other": "{{count}} résultats",
    "untitledRow": "Ligne sans titre",
    "untitledFrame": "Frame",
    "page": "Page {{page}}",
    "previewAlt": "Aperçu",
    "error": "Une erreur est survenue.",
    "errorWithMessage": "Une erreur est survenue : {{message}}.",
    "semanticUnavailable": "La recherche sémantique est indisponible pour le moment — le mode mots-clés fonctionne toujours.",
    "degraded": "Recherche sémantique indisponible — seuls les résultats par mots-clés sont affichés.",
    "typeFilter": {
      "label": "Filtrer par type de node",
      "showAll": "Tout afficher"
    },
    "typeDropdown": {
      "trigger": "Type",
      "triggerWithTypes": "Type : {{types}}",
      "remove": "Retirer {{type}}",
      "placeholder": "Filtrer par type…",
      "inputLabel": "Filtrer les types de node",
      "clear": "Effacer les types",
      "listLabel": "Types de node",
      "empty": "Aucun type correspondant"
    },
    "mode": {
      "label": "Mode de recherche",
      "keyword": {
        "full": "Mots-clés",
        "short": "Mots",
        "hint": "Recherche par mots-clés"
      },
      "auto": {
        "full": "Auto",
        "short": "Auto",
        "hint": "Recherche hybride"
      },
      "semantic": {
        "full": "Sémantique",
        "short": "Sém",
        "hint": "Recherche sémantique"
      }
    },
    "edited": {
      "trigger": "Modifié",
      "triggerWithValue": "Modifié : {{value}}",
      "any": "N'importe quand",
      "today": "Aujourd'hui",
      "week": "7 derniers jours",
      "month": "30 derniers jours"
    },
    "sort": {
      "trigger": "Trier",
      "label": "Tri : {{value}}",
      "relevance": "Pertinence",
      "edited": "Dernière modification",
      "created": "Création récente"
    }
  },
  "mobile": {
    "canvasLoadError": "Impossible de charger ce canvas",
    "nav": {
      "label": "Navigation principale",
      "canvas": "Canvas",
      "search": "Recherche",
      "chat": "Chat"
    },
    "workspaces": {
      "title": "Espaces de travail",
      "all": "Tous les espaces de travail",
      "create": "Nouvel espace de travail",
      "empty": "Aucun espace de travail",
      "shared": "Partagés avec vous",
      "fallbackName": "Espace de travail",
      "delete": "Supprimer l'espace de travail",
      "deleteConfirmTitle": "Supprimer l'espace de travail « {{name}} » ?",
      "deleteConfirmText": "Ses nodes et ses conversations seront supprimés avec lui."
    },
    "threads": {
      "title": "Conversations",
      "empty": "Aucune conversation sur ce canvas",
      "delete": "Supprimer la conversation"
    },
    "chat": {
      "newChat": "Nouvelle conversation",
      "history": "Historique des conversations",
      "dictationHint": "Maintenez le bouton du micro et parlez pour dicter",
      "answerPlaceholder": "Tapez votre réponse à la question de Nolë…",
      "dictationEngine": "Moteur de dictée",
      "holdToDictate": "Maintenir pour dicter"
    },
    "toolbar": {
      "addBlock": "Ajouter un bloc",
      "redo": "Rétablir"
    },
    "overlay": {
      "back": "Retour au chat",
      "refresh": "Actualiser",
      "moreOptions": "Plus d'options",
      "navigateToNode": "Aller au node",
      "history": "Historique",
      "threads": "Conversations ayant modifié ce node"
    }
  }
}
